<template>
  <div class>
    <main class="md:w-full md:h-screen md:overflow-auto md:pb-4 grid md:block bg-up-down-butterfly bg-up-down-butterfly--login-page">
      <section class="md:grid md:grid-cols-1 justify-items-center md:px-44 px-7 bg-greyBackground h-auto">
        <div class="col-span-1 md:grid">
          <div class="md:shadow-cardShadow card-w justify-self-end opacity-100 rounded-rounded4xl mb-14 bg-greyBackground md:px-16 md:pt-14 md:pb-12  md:grid items-start md:gap-8 gap-4 min-w-formFullWidth" v-if="dataLoaded">
            <router-view v-slot="{ Component }">
              <transition-page>
                <component :is="Component" />
              </transition-page>
            </router-view>
          </div>
        </div>
      </section>
    </main>
    <transition name="fade">
      <modal @close-modal="true" v-if="errorMessage">
        <div
          class="bg-white px-6 pt-4 pb-6 grid gap-8 justify-items-center w-full rounded-t-2xl text-center"
        >
        <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
          <div class="grid gap-6 justify-center justify-items-center w-full">
            <img src="../assets/mandate-failure.svg" alt="Error" width="119" height="115" />
              <div class="grid px-4 gap-4">
                <p class="label-text-headingColor-myriad font-semibold">{{ errorMessage }}</p>
                <p class="label-text-headingColor-myriad">Please contact support team <br/>
                  <a class="underline text-primary font-bold"
                    @click="supportClicked()"
                    href="tel:+918100050505">
                    +91-8100050505
                  </a>
                </p>
              </div>
          </div>
          <div class="grid w-full">
            <custom-button class="" variant="primary" type="button" @click="resetErrorMessage()">Ok</custom-button>
          </div>
        </div>
      </modal>
    </transition>
  </div>
  <!-- Spin Loader -->
  <spin-loader :spinLoading="isSpinLoading"/>
</template>
<script>
import { mapGetters } from 'vuex';
import { LogoutIcon } from '@heroicons/vue/outline';
import Navbar from '../components/Navbar.vue';
import Modal from '../components/Modal.vue';
import CustomButton from '../components/CustomButton.vue';
import TransitionPage from '../components/TransitionPage.vue';
import Title from '../components/Title.vue';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'Signup',
  components: {
    Navbar,
    Modal,
    CustomButton,
    TransitionPage,
    Title,
    LogoutIcon,
    SpinLoader
  },
  computed: {
    ...mapGetters([
      'applicationId',
      'errorMessage',
      'isReferralFlow',
      'isAndroidUser',
      'fullName',
      'supportId',
      'skipVideoVerification',
      'isOkCredit',
      'imageUrl',
      'bestApprovedAmount',
      'referralCallbackUrl',
      'skipBusinessRegistration',
      'isWalmart',
      'marketplaceInfo',
      'welcomeRewardsData',
      'flagsData',
      'videoVerified',
      "documentListUploaded",
      "errorCode",
      'latestLoanId'
    ]),
    whatsAppMessage() {
      return this.fullName
        ? encodeURIComponent(
          `Hi, I am ${this.fullName} and I am on ${this.$route.meta.displayName || this.$route.name
          } screen. I need assistance with on-boarding.`
        )
        : encodeURIComponent(
          `Hi, I am on ${this.$route.meta.displayName || this.$route.name
          } screen and I need some assistance.`
        );
    },
    whatsAppLink() {
      if (this.supportNumber) {
        return `https://api.whatsapp.com/send?phone=91${this.supportNumber}&text=${this.whatsAppMessage}`;
      }
      return undefined;
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      dataLoaded: undefined,
      supportNumber: undefined,
      isSpinLoading: undefined,
    };
  },
  watch: {
    $route() {
      // eslint-disable-next-line no-restricted-globals
      history.pushState(null, document.title, location.href);
      window.addEventListener('popstate', () => {
        // eslint-disable-next-line no-restricted-globals
        history.pushState(null, document.title, location.href);
      });
      // this.home();
    },
  },
  created() {
    this.resetErrorMessage();
  },
  methods: {
    init() {
      const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
      if (urlParams.search.substring(0).split('=')[0] === '?session') {
        this.NewPhoneBySession();
      } else {
        this.$store.commit('SET_ERROR_MESSAGE', undefined);
        this.redirectToFlow();
      }
    },
    redirectToFlow() {
      const { supportId } = this.$route.query;
      if (supportId) {
        this.$store.commit('SET_SUPPORT_ID', supportId);
      }
      const token = localStorage.getItem('token');
      if (token) {
        this.$store.commit('PARSE_JWT', token.split(' ')[1]);
      }
      this.home().then((result) => {
        if (this.applicationId) {
          this.summary().then(() => {
            this.dataLoaded = true;
          });
        }
        if (result?.application.applicationRejected) {
          this.$router.push({
            name: "Application Rejected",
          });
        } else if (this.$route.name !== "Application Discrepancy") {
          // GoTo Application subStatus Checking
          this.resolveRoute(result);
        } else {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SIGNUP_FAILURE, {
            [this.$mixpanelPayload.ERROR_REASON]: 'applicationRejected not and Application Discrepancy present'
          });
        }
      });
      if (this.supportId) {
        this.$store
          .dispatch('customerSupport', { supportId: this.supportId })
          .then((result) => {
            this.supportNumber = result.agencyContactPersonNumber;
          })
          .catch(() => { });
      } else if (this.isReferralFlow) {
        this.supportNumber = process.env.VUE_APP_REFERRAL_SUPPORT_NUMBER;
      }
    },
    logout() {
      this.$store.dispatch('customerLogout');
    },
    NewPhoneBySession() {
      const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
      const sessionId = urlParams.search.substring(0).split('=')[1].split('&')[0];
      return new Promise((resolve, reject) => {
        this.$store
        .dispatch("NewPhoneBySession", { queryParams: { sessionId } })
        .then((result) => {
          if (localStorage.getItem("phone") !== result.phone || result.phone === null || result.phone === undefined) {
            localStorage.setItem("newUrl", urlParams.href);
            this.logout();
          } else {
              this.redirectToFlow();
          }
        })
        .catch(() => {
          reject(
            this.logout()
          );
        });
      });
    },
    home() {
      this.isSpinLoading = true;
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('HomeGPayFetchDetails')
          .then((response) => {
            const uuid = response?.customer?.uuid;
            this.$trackUuid(uuid);
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_FETCH_DETAILS_API, {
              [this.$mixpanelPayload.REASON]: 'success',
              [this.$mixpanelPayload.KEY_MESSAGE]: `Status: ${response?.application.status?.value}, subStatus: ${response?.application.subStatus}, UUID: ${uuid}, res: ${response}`,
            });
            this.isSpinLoading = false;
            resolve(response);
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_FETCH_DETAILS_API, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message
            });
            this.isSpinLoading = false;
            reject();
          });
      });
    },
    summary() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('applicationSummary', {
            applicationId: this.applicationId,
          })
          .then((res) => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_SUMMARY_API, {
              [this.$mixpanelPayload.REASON]: 'success',
              [this.$mixpanelPayload.KEY_MESSAGE]: res
            });
            resolve();
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_SUMMARY_API, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message
            });
            reject();
          });
      });
    },
    customerLogout() {
      this.$store.dispatch('customerLogout');
    },
    resetErrorMessage() {
      if (navigator.onLine) {
        if (this.errorMessage === 'Apologies! Currently we are experiencing heavy load. Please try again in sometime!') {
          this.init();
        } else {
          this.$store.commit('SET_ERROR_MESSAGE', undefined);
        }
      } else {
        this.$store.commit('SET_ERROR_MESSAGE', undefined);
      }
    },
    getApplicationApprovals(businessUpdated) {
      this.$store
        .dispatch('applicationApprovals', {
          applicationId: this.applicationId,
          urlParams: {
            option: 'best',
          },
        })
        .then((response) => {
          if (response?.result[0]?.amountApproved === 0 && response?.result[0]?.skipOfferScreen) {
            this.$router.push({
              name: 'Current Address',
              query: {
                skipOfferScreen: true,
              }
            });
          } else if (response?.result[0]?.amountApproved === 0 && !response?.result[0]?.skipOfferScreen) {
            this.$router.push({
              name: "Application Rejected",
            });
          } else if (response?.result[0]?.amountApproved > 0) {
            if (businessUpdated) {
              localStorage.setItem('creditOfferData', JSON.stringify(response?.result[0]));
              this.$router.push({
                name: 'Credit Offer Selection',
              });
            } else {
              this.$router.push({
                name: 'Pre Approval Step 1',
              });
            }
          } else {
            this.$router.push({
              name: "Application Rejected",
            });
          }
        })
        .catch(() => { });
    },
    async redirectDocumentUploadDetails() {
      await this.summary();
      const d = this.documentListUploaded;
      const hasDocs = {
        aadhaar: d.aadhaarFrontUploaded && d.aadhaarBackUploaded,
        dl: d.drivingLicenseUploaded,
        voter: d.voterIdUploaded,
        passport: d.passportFrontUploaded && d.passportBackUploaded
      };
      const validDocCount = Object.values(hasDocs).filter(Boolean).length;
      this.$router.push({
        name: validDocCount > 0 ? 'Current Address' : 'Pre Approval KYC Selection',
      });
    },
    resolveRoute(response) {
      const applicationSubStatus = response?.application?.subStatus;
      const applicationStatus = response?.application?.status?.value;
      const isAllowedStatus = this.$route.meta.allowedStatus?.find(
        (status) => status === applicationSubStatus
      );
      if (!isAllowedStatus) {
        if (applicationStatus === 'approvedForSubmission') {
          this.$router.push({
            name: 'Product Card'
          });
        } else {
          switch (applicationSubStatus) {
            case undefined:
              this.$store
                .dispatch('application')
                .then(() => {
                  this.summary().then(() => {
                    this.dataLoaded = true;
                    this.$router.push({ name: 'Personal Profile Step 1' });
                  });
                })
                .catch(() => { });
              break;
            case 'initiated':
              this.$router.push({ name: 'Personal Profile Step 1' });
              break;
            case 'tncAccepted':
              this.$router.push({
                name: 'Pre Approval Step 1',
              });
              break;
            case 'serviceabilityChecked':
              this.getApplicationApprovals(response?.businessUpdated);
              break;
            case 'addressProofAsPerIdUploaded':
            case 'addressProofIdNumberUpdated':
              if (response?.businessUpdated) {
                this.redirectDocumentUploadDetails();
              } else {
                this.$router.push({
                  name: 'Pre Approval Step 1',
                });
              }
              break;
            case 'digiLockerVerified':
              this.$router.push({
                name: 'Current Address'
              });
              break;
            case 'personalInfoUpdated':
              if (response?.businessUpdated) {
                this.$router.push({ name: 'Pre Approval Step 3' });
              } else {
                this.$router.push({
                  name: 'Pre Approval Step 1',
                });
              }
              break;
            case 'businessInfoUpdated':
                this.$router.push({
                  name: 'Product Card'
                });
              break;
            case 'businessRegistrationDetailsUpdated':
            case 'businessRegistrationDetailsSkipped':
              this.$router.push({
                name: 'Pre Approval Step 3',
              });
              break;
            case 'opsApproved':
              this.$router.push({
                name: 'Suppliers',
              });
              break;
            default:
              break;
          }
        }
      }
    },
    supportClicked() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SUPPORT_CLICKED, {
        [this.$mixpanelPayload.ERROR_REASON]: this.errorMessage,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.grid-cols-nav {
  grid-template-columns: 1fr minmax(0, 48rem) 1fr;
}
.disFlex{
  display: flex !important;
}
</style>
